import { LitElement, html } from 'lit';
// import translate from '../utils/webcomponents/translate';

import Tooltip from './tooltip';
import './icon';

class CopyValueButton extends LitElement {
	static get properties() {
		return {
			icon: { type: String },
			value: { type: String },
			labelAction: { type: String },
			labelSuccess: { type: String },
		};
	}

	constructor() {
		super();

		this.value = '';
		this.labelAction = 'Copy';
		this.labelSuccess = 'Copied!';
	}

	firstUpdated() {
		super.firstUpdated();

		this.createTooltip();
	}

	createTooltip() {
		const tooltipEl = this.querySelector('[data-option-tooltip-text]');

		this.tooltip = new Tooltip(tooltipEl).start();
	}

	onClick() {
		this.copyValue();
	}

	onMouseLeave() {
		this.tooltip.hide();

		setTimeout(() => {
			this.tooltip.setContent(this.labelAction);
		}, 100);
	}

	async copyValue() {
		await navigator.clipboard.writeText(this.value);

		this.tooltip.setContent(this.labelSuccess);
	}

	render() {
		return html`
			<div>
				<button
					class="button button--ghost button--icon-only"
					data-option-tooltip-text="${this.labelAction}"
					@click="${this.onClick}"
					@mouseleave="${this.onMouseLeave}"
				>
					<span class="button__icon">
						<x-icon icon="copy"></x-icon>
					</span>
				</button>
			</div>
		`;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-copy-value-button', CopyValueButton);

export default CopyValueButton;
